/**
 * Collapsable
 *
 * When an item is constructed we get the title (the trigger) and the text.
 * We want to show the text whenever the title is clicked.
 *
 * We get the clientHeight of our text and then set its height to 0.
 * We do this because if we need a smooth transition that's always pixel perfect we need
 * the exact height of our text.
 *
 * Whenever the trigger is clicked toggle between height 0 and this.textHeight
 * Transitions are handled via CSS in collapsable.scss
 */
export default class Collapsable {

    constructor($collapsable) {
        this.$collapsable = $collapsable;
        this.$title = this.$collapsable.querySelector('[data-collapsable-title]');
        this.$text = this.$collapsable.querySelector('[data-collapsable-text]');
        this.textHeight = this.$text.scrollHeight;

        // this.$text.style.height = 0;

        this.toggleCollapsable = this.toggleCollapsable.bind(this);

        if (this.$collapsable.dataset.collapsable === 'open') {
            this.toggleCollapsable();
        }

        this.$title.addEventListener('click', this.toggleCollapsable);
    }

    toggleCollapsable() {

        // if our collapsable text is 0px high, we open it
        if (! this.$text.classList.contains('collapsable__item__text--open')) {
            this.$text.classList.add('collapsable__item__text--open');
            // this.$text.style.height = this.textHeight + 'px';
        }
        else {
            this.$text.classList.remove('collapsable__item__text--open');
            // this.$text.style.height = 0;
        }
    }
}